import api from './client';

export interface ProxyStats {
  total: number;
  successes: number;
  failures: number;
  avg_duration_ms: number;
  by_operation: {
    operation: string;
    total: number;
    successes: number;
    failures: number;
    success_rate: number;
    avg_duration_ms: number;
  }[];
}

export interface ProxyError {
  timestamp: string;
  operation: string;
  error: string;
}

export interface ProxyLogEntry {
  ts: string;
  level: string;
  step: string;
  message: string;
}

export interface ProxyOperation {
  timestamp: string;
  operation: string;
  username: string;
  operator_email: string;
  success: boolean;
  error: string;
  duration_ms: number;
}

export interface ProxySystemInfo {
  hostname: string;
  platform?: string;
  uptime_seconds?: number;
}

export interface ProxyInfo {
  org_id: string;
  org_name: string;
  proxy_url: string | null;
  proxy_version: string;
  proxy_last_seen: string | null;
  proxy_stats: ProxyStats | null;
  proxy_recent_errors: ProxyError[];
  proxy_recent_logs: ProxyLogEntry[];
  proxy_recent_operations: ProxyOperation[];
  proxy_system_info: ProxySystemInfo | null;
  servicebox_enabled: boolean;
  servicebox_username: string;
  pending_commands: { action: string; queued_at: string }[];
}

export interface LatestVersion {
  version: string | null;
  tag?: string;
  published_at?: string;
}

export const proxyAdminApi = {
  list: async (): Promise<ProxyInfo[]> => {
    const { data } = await api.get('/admin/proxies');
    return data;
  },

  sendCommand: async (orgId: string, action: string) => {
    const { data } = await api.post(`/admin/proxies/${orgId}/command`, { action });
    return data;
  },

  getLatestVersion: async (): Promise<LatestVersion> => {
    const { data } = await api.get('/admin/proxies/latest-version');
    return data;
  },
};
